import { initialState } from '@store/constants';
import { useItemActivityId } from '@store/item/context/ItemActivityContext';
import { RootState } from '@store/store';
import { useSelector } from 'react-redux';

const hotNames = [
    'HOT', 'HOT(ML)',
];

function useIsHotSelected(): boolean {
    const activityId = useItemActivityId();
    const { orderLines } = useSelector((state: RootState) => state.item[activityId] ?? initialState);
    const allOptions = orderLines
        .map((line) => [...line.defaultOptions, ...line.personalOptions])
        .flat()
        .map((it) => it.options)
        .flat();

    return !!allOptions.find((it) => hotNames.includes(it.optionName));
}

export default useIsHotSelected;
